module.exports = __webpack_public_path__ + "img/citrix.febfbc18.webp";